import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { fetchTopicContentMetaFailure, fetchTopicContentMetaSuccess } from "domains/topicSearchFilter/actions";
import type { TopicFetchContentMetaSuccessAction } from "domains/topicSearchFilter/actionTypes";

export function* fetchTopicFiltersSaga() {
  try {
    const payload: TopicFetchContentMetaSuccessAction["payload"] = yield apiFetch("topic/content_meta");
    yield put(fetchTopicContentMetaSuccess(payload));
  } catch {
    yield put(fetchTopicContentMetaFailure({ logoutOnAuthError: true }));
  }
}
